import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAlert = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.8019 2.0575L22.7319 17.8875H22.7219C23.5019 19.2775 22.5119 20.9975 20.9219 20.9975H3.07192C1.48192 20.9975 0.491921 19.2775 1.27192 17.8875L10.2019 2.0575C10.9919 0.6475 13.0119 0.6475 13.8019 2.0575ZM12.0019 7.9975C11.5119 7.9975 11.1219 8.3975 11.1219 8.8775H11.1319V13.9975H12.8819V8.8775C12.8819 8.3875 12.4919 7.9975 12.0019 7.9975ZM11.0019 16.9975C11.0019 17.5475 11.4519 17.9975 12.0019 17.9975C12.5519 17.9975 13.0019 17.5475 13.0019 16.9975C13.0019 16.4475 12.5519 15.9975 12.0019 15.9975C11.4519 15.9975 11.0019 16.4475 11.0019 16.9975Z'
    />
  </svg>
);
export default SvgAlert;
